/*       */
import { loadData } from 'app/utils/redux/action-utils';
import autocompleteQuery from 'graphql/entities/tasks/tasksAutocompleteQuery';
import taskLoadAvatarQuery from 'graphql/entities/tasks/taskLoadAvatarQuery';
import { getAvatar } from 'app/utils/avatar/avatar';

export const LOAD_TASKS_AUTOCOMPLETE_STARTED = '@@affectli/entities/tasks/LOAD_TASKS_AUTOCOMPLETE_STARTED';
export const LOAD_TASKS_AUTOCOMPLETE = '@@affectli/entities/tasks/LOAD_TASKS_AUTOCOMPLETE';

export const LOAD_AVATAR_STARTED = '@@affectli/entities/tasks/LOAD_AVATAR_STARTED';
export const LOAD_AVATAR = '@@affectli/entities/tasks/LOAD_AVATAR';

export const loadAvatar = (id, additionalQueryProps) => (dispatch, getState) => {
    let avatar = getAvatar(getState(), 'task', id);
    if (avatar && (avatar.isLoading || avatar.loadedAt > Date.now() - 60 * 60 * 1000)) {
        // if we are loding the avatar or it is already loaded and it is stored less then 1 hour ago
        // we return the data in the state without calling the service
        return Promise.resolve(avatar);
    }
    avatar = loadData(LOAD_AVATAR_STARTED, LOAD_AVATAR, taskLoadAvatarQuery(additionalQueryProps))({ id, filterBy: [{ field: 'id', op: '=', value: id }] })(
        dispatch,
        getState
    );
    return avatar && avatar[0];
};

export const loadTasksAutocomplete = loadData(LOAD_TASKS_AUTOCOMPLETE_STARTED, LOAD_TASKS_AUTOCOMPLETE, autocompleteQuery);
